/**
 * IS_MOBILE_EXPERIENCE
 *
 * True  → phone, tablet, iPad, Android, iOS, or any touch-primary device.
 *          These clients get the mobile game experience.
 *
 * False → Mac / Windows desktop or laptop browser (cursor-primary).
 *          These clients get the desktop game experience.
 *
 * Evaluated ONCE at module load — never changes during the session.
 * Use this everywhere instead of ad-hoc window.innerWidth breakpoints.
 *
 * Detection order (any one being true is sufficient):
 *  1. pointer: coarse  — primary pointer is a finger (touch screen)
 *  2. hover: none      — device cannot hover (touch-only)
 *  3. UA string        — iOS / Android user agent
 *  4. narrow viewport  — canvas ≤ 768 px wide (covers Chrome DevTools emulation
 *                         and any browser that doesn't expose touch media queries
 *                         correctly; real desktops are never this narrow)
 */
export const IS_MOBILE_EXPERIENCE: boolean = (() => {
  if (typeof window === 'undefined') return false;           // SSR guard
  const coarse  = window.matchMedia('(pointer: coarse)').matches;
  const noHover = window.matchMedia('(hover: none)').matches;
  const ua      = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const narrow  = window.innerWidth <= 768;
  return coarse || noHover || ua || narrow;
})();
